module.exports = __webpack_public_path__ + "img/bg_login.a7fb8724.png";